import { render, staticRenderFns } from "./ListQuotation.vue?vue&type=template&id=38d8ca35&"
import script from "./ListQuotation.vue?vue&type=script&lang=js&"
export * from "./ListQuotation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports